import { CaretUp } from 'assets/icons';
import CustomLink from 'components/shared/CustomLink';

/**
 * COD is not offered in India; every other region keeps this answer.
 * Filtered out by getDieselRingFaqData(isIndia) below.
 */
const codFaqItem = {
  title: 'Is Cash on Delivery (COD) available?',
  description: (
    <>
      Yes, Cash on Delivery (COD) is available. Please note that if your order
      includes a sizing kit, the payment will be collected when the sizing kit
      is delivered.
    </>
  ),
};

export const dieselRingFaqDataPricingPage = [
  {
    title: 'How do I choose the right ring size for me?',
    description: (
      <>
        If you&apos;re uncertain about your Diesel Ultrahuman Ring size, we
        recommend opting for the free sizing kit that we&apos;ll promptly
        dispatch it upon placing a Ring order. The sizing kit includes
        high-quality plastic ring sizers ranging from sizes 5 to 14. Please note
        that Diesel Ultrahuman Ring sizes may differ slightly from standard US
        ring sizes, and we don&apos;t offer half sizes. If you are already
        acquainted with your Ultrahuman Ring (R1), or Ultrahuman Ring AIR size,
        you&apos;ll find the Diesel Ultrahuman Ring will fit you just the same.
      </>
    ),
  },
  {
    title: 'What sizes of the Diesel Ultrahuman Ring are available?',
    description: (
      <>
        Diesel Ultrahuman Ring is available in 10 sizes ranging from the lowest
        size of 5 to the highest size of 14.
      </>
    ),
  },
  {
    title: 'Why does the Diesel Ultrahuman Ring cost higher than Ring AIR?',
    description: (
      <>
        <p>
          Each ring is manually crafted and meticulously inspected to create its
          distinctive worn-in aesthetic. Like a great pair of jeans, the Diesel
          Ultrahuman Ring ages with you, developing character over time and
          evolving into a look that’s uniquely yours.
        </p>
        <br />
        <p>
          This blend of advanced engineering and meticulous hand-finishing makes
          it significantly more time-intensive to produce, which is why it’s
          priced higher than the Ring AIR.
        </p>
      </>
    ),
  },
  {
    title: 'Which finger is optimal for wearing the ring?',
    description: (
      <>
        We suggest wearing the ring on your index, middle, or ring finger. The
        ultimate choice among these depends on which finger provides the most
        comfortable fit or aligns with your personal preference.{' '}
        <CustomLink
          href="https://www.notion.so/22aa9960c9b649dda983ca21bfa5ac34?pvs=21"
          target={'_blank'}
        >
          Here&apos;s a more detailed guide
        </CustomLink>{' '}
        to determining the right ring size.
      </>
    ),
  },
  {
    title:
      'Do the Diesel Ultrahuman Ring sizes correspond to those of other smart rings or the Ultrahuman Rings?',
    description: (
      <>
        The sizing of the Diesel Ultrahuman Ring is unique and does not directly
        align with that of other smart rings. However, we offer a complimentary
        ring sizing kit to help you determine the perfect fit. If you are
        already acquainted with your Ultrahuman Ring (R1), or Ultrahuman Ring
        AIR size, you&apos;ll find the Diesel Ultrahuman Ring will fit you just
        the same.
      </>
    ),
  },
  {
    title: "I placed my ring order, what's next?",
    description: (
      <>
        Upon placing your order, we will promptly process your request for a
        physical Diesel Ultrahuman Ring sizing kit if you have chosen to receive
        one. Once you have determined your size and submitted it to us (if you
        haven&apos;t done so at the time of placing the order), you can expect
        the delivery of your Diesel Ultrahuman Ring within approximately four to
        six weeks.
      </>
    ),
  },
  {
    title: 'Is there any subscription fee to access ring data?',
    description: (
      <>
        Rest assured, there are no recurring subscription fees for accessing
        your data. Diesel Ultrahuman Ring is available for a simple, one-time
        purchase, paid upfront. This purchase gives you lifelong access to both
        the ring and your personal data.
      </>
    ),
  },
  {
    title: ' ',
    description: (
      <>
        <CustomLink href="/diesel-ultrahuman-ring/faq">
          See all FAQs{' '}
          <CaretUp
            style={{ transform: 'rotate(90deg)' }}
            width={14}
            height={14}
          />
        </CustomLink>
      </>
    ),
  },
];

export const dieselRingFaqData = [
  {
    title: 'How do I choose the right ring size for me?',
    description: (
      <>
        If you&apos;re uncertain about your Diesel Ultrahuman Ring size, we
        recommend opting for the free sizing kit that we&apos;ll promptly
        dispatch it upon placing a Ring order. The sizing kit includes
        high-quality plastic ring sizers ranging from sizes 5 to 14. Please note
        that Diesel Ultrahuman Ring sizes may differ slightly from standard US
        ring sizes, and we don&apos;t offer half sizes. If you are already
        acquainted with your Ultrahuman Ring (R1), or Ultrahuman Ring AIR size,
        you&apos;ll find the Diesel Ultrahuman Ring will fit you just the same.
      </>
    ),
  },
  {
    title: 'What sizes of the Diesel Ultrahuman Ring are available?',
    description: (
      <>
        Diesel Ultrahuman Ring is available in 10 sizes ranging from the lowest
        size of 5 to the highest size of 14.
      </>
    ),
  },
  {
    title: 'Which finger is optimal for wearing the ring?',
    description: (
      <>
        We suggest wearing the ring on your index, middle, or ring finger. The
        ultimate choice among these depends on which finger provides the most
        comfortable fit or aligns with your personal preference.{' '}
        <CustomLink
          href="https://www.notion.so/22aa9960c9b649dda983ca21bfa5ac34?pvs=21"
          target={'_blank'}
        >
          Here&apos;s a more detailed guide
        </CustomLink>{' '}
        to determining the right ring size.
      </>
    ),
  },
  {
    title:
      'Do the Diesel Ultrahuman Ring sizes correspond to those of other smart rings or the Ultrahuman Rings?',
    description: (
      <>
        The sizing of the Diesel Ultrahuman Ring is unique and does not directly
        align with that of other smart rings. However, we offer a complimentary
        ring sizing kit to help you determine the perfect fit. If you are
        already acquainted with your Ultrahuman Ring (R1), or Ultrahuman Ring
        AIR size, you&apos;ll find the Diesel Ultrahuman Ring will fit you just
        the same.
      </>
    ),
  },
  {
    title: "I placed my ring order, what's next?",
    description: (
      <>
        Upon placing your order, we will promptly process your request for a
        physical Diesel Ultrahuman Ring sizing kit if you have chosen to receive
        one. Once you have determined your size and submitted it to us (if you
        haven&apos;t done so at the time of placing the order), you can expect
        the delivery of your Diesel Ultrahuman Ring within approximately four to
        six weeks.
      </>
    ),
  },
  {
    title: 'Is there any subscription fee to access ring data?',
    description: (
      <>
        Rest assured, there are no recurring subscription fees for accessing
        your data. Diesel Ultrahuman Ring is available for a simple, one-time
        purchase, paid upfront. This purchase gives you lifelong access to both
        the ring and your personal data.
      </>
    ),
  },
  codFaqItem,
  {
    title: 'Guidelines on purchasing the ring from countries other than India',
    description: (
      <>
        Please note that it is your responsibility to verify, with your local
        regulatory or competent authorities, whether the Diesel Ultrahuman Ring
        you intend to order or have ordered can be legally imported and used in
        your country of residence. We recommend obtaining confirmation from
        local authorities before placing an order on our website. The Diesel
        Ultrahuman Ring available for purchase on our website is compliant with
        Indian laws and regulations. Ultrahuman disclaims any liability for
        non-compliance with local laws if the Diesel Ultrahuman Ring and our
        services are used or imported into any other country. Please be aware
        that the ring may be subject to taxes, customs duties, and destination
        country fees (Import Fees). You, as the recipient of the shipment, are
        responsible for all Import Fees.
      </>
    ),
  },
  {
    title: 'What benefits do UltrahumanX subscribers enjoy?',
    description: (
      <>
        <strong>UltrahumanX 1-Year Coverage Plan:</strong>
        <br />
        <br />
        <ul>
          <li>
            Accidental damage protection: Enjoy coverage for accidental damage
            or knocks, redeemable once during your UltrahumanX coverage period.
          </li>
          <li>
            Priority support: No request is too small. We&apos;re here to
            quickly resolve all your queries.
          </li>
        </ul>
        <br />
        <strong>UltrahumanX 2-Year Coverage Plan:</strong>
        <br />
        <br />
        <ul>
          <li>Includes all 1-Year Coverage benefits</li>
          <li>
            Theft and loss coverage: Your peace of mind is important. We&apos;ll
            cover theft or loss with a free replacement, redeemable once during
            your UltrahumanX coverage period.
          </li>
          <li>
            Weight loss insurance: Achieved your weight loss goals? We&apos;ll
            make resizing easy with a free Diesel Ultrahuman Ring replacement,
            redeemable once during your UltrahumanX coverage period.
          </li>
        </ul>
      </>
    ),
  },
  {
    title: 'In what colours is the ring available?',
    description: (
      <>
        The Diesel Ultrahuman Ring is available in two colours — Phantom
        (Distressed Black) and Cryo (Shiny Silver).
      </>
    ),
  },
  {
    title: 'What is the battery life of the ring?',
    description: (
      <>
        When fully charged, the ring is designed to operate for approximately
        4-6 days under standard usage conditions. However, specific factors such
        as battery lifespan, environmental temperature, and frequency of use can
        influence this duration. You can anticipate approximately 500 charging
        cycles before there is any significant decline in battery performance.
        As is common with all battery-powered devices, a gradual reduction in
        battery life can be expected after 1 to 2 years. Please note that
        battery-related replacements are not covered beyond the warranty period.
      </>
    ),
  },
  {
    title: 'Which devices are compatible with the ring?',
    description: (
      <>
        The Diesel Ultrahuman Ring is designed to seamlessly interface with
        iPhones operating on iOS 15 or newer, as well as Android devices
        functioning on Android 6 or subsequent versions.
      </>
    ),
  },
  {
    title: 'What is Diesel Ultrahuman Ring made of?',
    description: (
      <>
        The Diesel Ultrahuman Ring is meticulously crafted from durable titanium
        and further reinforced with a tungsten carbide coating, augmenting its
        resilience for everyday activities.
      </>
    ),
  },
  {
    title: 'How does the ring capture and measure body signals?',
    description: (
      <>
        The Diesel Ultrahuman Ring employs an array of sensors, including a
        temperature sensor, a PPG (photoplethysmography) sensor, and a
        motion-sensing IMU (inertial measurement unit). By capturing signals
        from your finger, these sensors enable the ring to collect vital data.
        These signals are then processed using advanced algorithms, developed by
        Ultrahuman, to provide you with profound metabolic insights and a
        comprehensive understanding of your body&apos;s dynamics.
      </>
    ),
  },
  {
    title: 'What is Heart Rate Variability (HRV)?',
    description: (
      <>
        Heart Rate Variability, commonly abbreviated as HRV, refers to the
        extent of fluctuation or variation in your heart rate over a specific
        timeframe. HRV serves as a valuable metric for assessing physical
        well-being, including heart conditions, as well as mental health factors
        such as anxiety and stress levels. Generally, a higher HRV is regarded
        as an indication of better overall health.
      </>
    ),
  },
  {
    title: 'Are there distinct features on the app for Diesel Ultrahuman Ring?',
    description: (
      <>
        The Diesel Ultrahuman Ring operates seamlessly with the existing
        functionalities within the ring section of the app. Should there be the
        introduction of new features, rest assured they will be made available
        for the Diesel Ultrahuman Ring, Ultrahuman Ring AIR, and the Ultrahuman
        Ring (R1).
      </>
    ),
  },
  {
    title: 'What specific parameters can the ring monitor?',
    description: (
      <>
        The Diesel Ultrahuman Ring is capable of tracking a comprehensive range
        of metrics associated with Sleep, Movement, and Recovery. This includes
        Heart Rate, HRV, Body Temperature, SPO2, Sleep Stages, Movement
        Frequency, and Recovery patterns, among others. Additionally, it offers
        real-time insights designed to guide you towards making healthier daily
        decisions. These metrics are also seamlessly integrated with the broader
        Ultrahuman ecosystem of products, such as the Ultrahuman M1.
      </>
    ),
  },
  {
    title:
      'How do Diesel Ultrahuman Ring and M1 sync to promote metabolic health?',
    description: (
      <>
        The Diesel Ultrahuman Ring and Ultrahuman M1 work in synergy to provide
        valuable insights into your metabolic health. By combining glucose data
        from the M1 with data on movement, sleep, and body metrics collected by
        the ring, deep correlations can be established. This helps us identify
        how certain foods impact glucose levels, allowing for proactive
        recommendations on activities or interventions to counter or assist
        these effects. The integration of M1 and Ring data empowers us to offer
        personalized and precise insights tailored to your unique metabolic
        health needs.
      </>
    ),
  },
  {
    title: 'How do Diesel Ultrahuman Ring and M1 sync to improve sleep health?',
    description: (
      <>
        By leveraging the combined data on Sleep and Glucose, we can analyze in
        real-time how glucose spikes impact your sleep. For example, if
        higher-than-usual glucose spikes occur after a meal, it may be
        correlated with poor sleep quality. Real-time nudges will help you take
        appropriate actions to assist the situation.
      </>
    ),
  },
  {
    title: 'What distinguishes the Diesel Ultrahuman Ring from the Ring AIR?',
    description: (
      <>
        The Diesel Ultrahuman Ring exemplifies an evolution in design and user
        experience. The Diesel Ultrahuman Ring has the cutting edge health
        technology present in the Ring AIR such as the advanced 6-axis motion
        sensors, medical grade temperature sensors and cutting edge
        photoplethysmography (ppg) technology. The Diesel Ultrahuman Ring takes
        design to a whole new level.
        <br />
        <br />
        The ring is available in two styles: shiny silver and distressed black,
        featuring the Diesel Double D logo. Each ring comes with a base charger
        in iconic Diesel red with the signature graphic logo, a C-to-C cable in
        Diesel&apos;s bold red-and-white packaging. It has 4–6 days of battery
        life, automatic syncing, and data privacy protection without a
        subscription.
        <br />
        <br />
        This partnership combines Diesel&apos;s inclusivity and cutting-edge
        cultural fluency with science-backed insights from Ultrahuman, the
        global leader in health optimization technology. Diesel Ultrahuman Ring
        embraces the power of personal performance and represents a celebration
        of self-expression through science and design.
      </>
    ),
  },
  {
    title:
      'How does the Diesel Ultrahuman Ring distinguish itself from other consumer wearable devices?',
    description: (
      <>
        Unlike many consumer wearables, the Diesel Ultrahuman Ring focuses
        specifically on providing insights into factors that influence our
        body&apos;s metabolism. It goes beyond traditional tracking by measuring
        key aspects such as sleep quality, sleep zones, stress levels (through
        HRV), and activity distribution. The distinctive feature lies in its
        capability to not only collect data but also correlate it with real-time
        nudges and insights, enabling users to make informed decisions for
        enhancing their metabolic health.
      </>
    ),
  },
  {
    title: 'How is the Diesel Ultrahuman Ring different from the M1 device?',
    description: (
      <>
        The Ultrahuman M1 is a platform that monitors your metabolic fitness
        with the help of a semi-invasive continue glucose monitor, providing
        valuable insights into how your body processes glucose. On the other
        hand, the Diesel Ultrahuman Ring is a non-invasive smart ring that
        focuses on measuring metabolic parameters such as sleep, stress,
        movement, and recovery. While each device can provide insights
        independently, they complement each other seamlessly.
      </>
    ),
  },
  {
    title: 'How accurate is the ring data?',
    description: (
      <>
        The metrics derived from the ring are meticulously benchmarked against
        industry-leading fitness wearable products available worldwide.
      </>
    ),
  },
  {
    title: 'Is the ring compatible with other CGMs?',
    description: (
      <>
        At present, the ring is exclusively compatible with the CGMs included in
        the Ultrahuman M1 plan.
      </>
    ),
  },
  {
    title: 'Can I wear the ring on a daily basis?',
    description: (
      <>
        Unquestionably! The Diesel Ultrahuman Ring has been crafted with
        hypoallergenic materials, ensuring its suitability for continuous,
        round-the-clock wear.
      </>
    ),
  },
  {
    title: 'Is it advisable to wear the ring while working out?',
    description: (
      <>
        The Diesel Ultrahuman Ring is fortified with a robust Tungsten carbide
        coating, affording it a high degree of resilience against daily wear and
        tear. Despite this, we advise against wearing your ring during intense
        weight training sessions or while handling heavy metal objects. Even
        repeated contact with relatively less hard substances can potentially
        leave a mark on the ring.
      </>
    ),
  },
  {
    title: 'Is the ring suitable for wearing underwater?',
    description: (
      <>
        Indeed! The Diesel Ultrahuman Ring boasts a water resistance rating that
        extends up to 100 meters, permitting wear during activities like
        swimming, showering, scuba diving and more. To maintain its optimal
        performance, we advise against keeping the ring submerged for periods
        exceeding 30 minutes continuously.
      </>
    ),
  },
  {
    title: 'What is the calibration duration for the ring?',
    description: (
      <>
        The Diesel Ultrahuman Ring typically requires a one-time calibration
        period of up to 7 days. Subsequent calibrations will only be necessary
        if the ring undergoes a hard reset.
      </>
    ),
  },
  {
    title: 'What is the required duration to fully charge the ring?',
    description: (
      <>
        The Diesel Ultrahuman Ring requires approximately 180 mins to reach a
        full charge.
      </>
    ),
  },
  {
    title: 'Is it possible to share the ring with other family members?',
    description: (
      <>
        Indeed, the ring can be shared with other family members, given that it
        is reset from the app. Please note that the ring should fit the new user
        properly. After resetting, the ring will require up to 7 days for
        recalibration before accurately tracking the new user&apos;s data.
      </>
    ),
  },
  {
    title: 'Does long-term wear of the ring have adverse effects on the skin?',
    description: (
      <>
        The design and construction of the ring prioritize skin health. Composed
        of hypoallergenic materials, it is perfectly suited for prolonged skin
        contact and ensures a comfortable fit. There is no need for concern
        about allergic reactions resulting from extended wear of the ring.
      </>
    ),
  },
  {
    title: 'What should I do if my ring gets stuck?',
    description: (
      <>
        Finger size can fluctuate during the day due to heat, activity,
        hydration, or food intake. This can make the ring feel tighter and
        harder to remove.
        <br />
        <br />
        If your ring feels stuck, try the following:
        <ul>
          <li>Run your hand under cold water to reduce swelling.</li>
          <li>Apply soap or a lubricant to your finger.</li>
          <li>Gently twist the ring while pulling it off. Do not force it.</li>
          <li>
            Raise your hand above heart level for a few minutes to reduce blood
            flow and swelling.
          </li>
          <li>
            If the tightness followed exercise, heat exposure, or a heavy meal,
            wait and try again later once swelling subsides.
          </li>
        </ul>
        <br />
        <b>If the ring still cannot be removed</b> and if none of the above
        methods work, seek medical assistance.
        <ul>
          <li>Do not attempt to cut the ring yourself.</li>
          <li>
            The ring contains an embedded battery and must be cut safely by a
            medical professional. The battery is located in the protruding
            section on the inside of the ring. The ring must be cut away from
            this area.
          </li>
          <li>
            Once cut, a flat-head tool may be used to gently widen the gap and
            remove the ring. If removal is still difficult, a second cut may be
            made approximately one centimeter to the left or right of the first
            cut, again avoiding the battery.
          </li>
          <li>
            After removal, handle the ring carefully as edges may be sharp, and
            dispose of it safely. Your safety comes first. The ring can always
            be replaced.
          </li>
        </ul>
      </>
    ),
  },
  {
    title: 'Is the ring EMF-safe?',
    description: (
      <>
        The Diesel Ultrahuman Ring operates as a low-power device that
        communicates with your smartphone using Bluetooth Low Energy (BLE)
        technology. It establishes a connection with the smartphone only when
        you open the Ultrahuman App or at regular time intervals, unlike
        Bluetooth headsets, earbuds, or smartwatches that maintain constant
        connectivity and data transmission/reception. It&apos;s important to
        note that Bluetooth activity for the Diesel Ultrahuman Ring remains
        below 1% throughout the day, resulting in significantly lower EMF
        radiation compared to other Bluetooth wearables. Consequently, the
        Diesel Ultrahuman Ring can be regarded as one of the safest wearable
        devices for fitness tracking in terms of EMF exposure.
      </>
    ),
  },
  {
    title: 'Is the ring considered a medical device?',
    description: (
      <>
        The Diesel Ultrahuman Ring is not classified as a medical device. It is
        designed solely for the purpose of promoting and facilitating a healthy
        lifestyle. The Diesel Ultrahuman Ring is not intended for managing,
        treating, or preventing diseases, and it should not be relied upon for
        making any diagnostic, treatment, or dosage decisions. It is not meant
        to substitute professional medical opinions or guidance regarding the
        treatment, diagnosis, prevention, or alleviation of any disease or
        disability.It is always important to consult with a doctor or qualified
        healthcare professional before making any changes to medications,
        routines, or nutrition, especially if you have any existing health
        conditions or concerns. Please be aware that the accuracy of biomarker
        data may be influenced if you have been diagnosed with a medical
        condition. Therefore, it is crucial not to disregard or delay seeking
        professional medical advice or treatment based on information obtained
        from or accessed through the Ultrahuman app.
      </>
    ),
  },
  {
    title:
      'Can I wear the ring alongside medical devices like a pacemaker or ICD?',
    description: (
      <>
        In general, wearing and using the Diesel Ultrahuman Ring should not
        interfere with the functionality of medical devices such as pacemakers
        or ICDs. However, we strongly recommend consulting with your physician
        before making a decision. The Diesel Ultrahuman Ring operates using a
        very low-power electromagnetic field, minimizing the likelihood of
        interference with these medical devices. If you suspect any interference
        or have concerns, discontinue the use of the ring and seek guidance from
        both your physician and the manufacturer of your medical device for
        specific guidelines and recommendations.
      </>
    ),
  },
  {
    title: 'Is the ring safe from Electrostatic Discharge (ESD)?',
    description: (
      <>
        Absolutely! The Diesel Ultrahuman Ring is designed to be ESD-safe,
        ensuring that you will not experience any electrostatic shocks from the
        ring.
      </>
    ),
  },
  {
    title: 'Is it safe to wear the ring on tattooed fingers?',
    description: (
      <>
        Yes, you can wear the ring on tattooed fingers. However, please note
        that if the tattoo is dark and heavy, it may affect the accuracy of the
        readings obtained from the ring.
      </>
    ),
  },
  {
    title:
      'What safety considerations have been incorporated into the design and construction of the ring?',
    description: (
      <>
        The Ultrahuman team prioritizes the safety and comfort of users in the
        design and engineering of their products. The Ultrahuman Rings have been
        meticulously crafted with user comfort in mind. The inner side of the
        rings features a transparent hypoallergenic plastic-based material that
        comes into contact with your skin, ensuring a comfortable experience.
        Additionally, the outer shell of the ring is constructed from Titanium,
        chosen for its durability and longevity. Titanium provides the necessary
        strength and resistance to deformation.In rare and exceptional
        circumstances, should the need arise, any Ultrahuman Ring can be safely
        removed using either manual or power ring cutters, ensuring the
        wearer&apos;s well-being.
      </>
    ),
  },
  {
    title: 'How should I dispose of the ring?',
    description: (
      <>
        The Ultrahuman Ring contains an internal battery, which classifies it as
        electronic waste (e-waste). To dispose of the battery responsibly, we
        recommend adhering to the regulations and guidelines outlined by your
        local laws and regulations regarding e-waste disposal. Additionally, the
        charger accompanying the ring is an electronic device and should also be
        disposed of in accordance with the applicable local electronics
        recycling laws and regulations.
      </>
    ),
  },
  {
    title: 'What is the warranty policy for Diesel Ultrahuman Ring?',
    description: (
      <>
        The Diesel Ultrahuman Ring is covered by a limited warranty that
        protects against defects in materials and workmanship. The warranty
        period lasts for one year from the date of delivery.
      </>
    ),
  },
  {
    title: 'What is the return policy for Diesel Ultrahuman Ring?',
    description: (
      <>
        Our return policy allows you to return the Diesel Ultrahuman Ring
        product within 30 days of delivery if you&apos;re not completely
        satisfied. The return must contain all original accessories, including
        the charger in their original packaging.
      </>
    ),
  },
  {
    title: 'Will I have to pay for return shipping?',
    description: (
      <>
        Return shipping is free. We will provide you with a shipping label once
        your return request is processed.
      </>
    ),
  },
  {
    title: 'What is the ring cancellation policy?',
    description: (
      <>
        You have the option to cancel your order within 7 days before the sizing
        kit has been shipped to you. In the rare event that none of the ring
        sizes provided in the sizing kit fit you, you can still cancel your
        order within 3 days of receiving the sizing kit.
      </>
    ),
  },
  {
    title: 'Terms of Sale',
    description: (
      <>
        You can find the Terms of Sale for Diesel Ultrahuman Ring{' '}
        <CustomLink
          href="https://www.ultrahuman.com/termsOfSale/UltrahumanRing/"
          target={'_blank'}
        >
          here
        </CustomLink>
        .
      </>
    ),
  },
];

/** /diesel-ultrahuman-ring/faq data — India drops the COD answer, all other regions keep it. */
export const getDieselRingFaqData = (isIndia: boolean) =>
  isIndia
    ? dieselRingFaqData.filter((item) => item.title !== codFaqItem.title)
    : dieselRingFaqData;
